import { ObjectMap } from '@/types/misc'

export interface EditCalendarCodeFormValues {
  code: string
}

export const EDIT_CALENDAR_CODE_FORM_FIELDS: ObjectMap<EditCalendarCodeFormValues> =
  { code: 'code' }

export const SHAREABLE_LINKS_TABLE_PAGE_SIZE = 7
